module.exports = __webpack_public_path__ + "img/ambatya_no.f596d5b0.png";